import UpgradeCycleModalPresenter from "./UpgradeCycleModalPresenter";
import { ProfileAccountInfo } from "api/interfaces/accountInterface.interface";
import { BILLING_CYCLE } from "api/interfaces/subscription.interface";
import { postDowngradeCycle } from "api/planAPI";
import { useMenu } from "hook/useMenu";
import useStatusMutation from "hook/useStatusMutation";
import useUsageSignupFlow from "pages/subscription/usage/signup/useUsageSignupFlow";
import { useCallback } from "react";
import { useAppSelector } from "redux/hooks";
import { isYearlyBillingCycle } from "utils/priceUtils";

interface Props {
  onModal: () => void;
}

export default function UpgradeCycleModalContainer({
  onModal,
}: Props): JSX.Element {
  const { accountId, cycle }: ProfileAccountInfo = useAppSelector(
    (state) => state.accountSettings
  );
  const { updateCurrentAccount } = useMenu({});

  const onConfirmToMonthly = () => {
    if (isYearlyBillingCycle(cycle)) {
      onMutateDowngrade();
    }
    return;
  };

  const transferCycle = isYearlyBillingCycle(cycle)
    ? BILLING_CYCLE.MONTHLY
    : BILLING_CYCLE.YEARLY;

  const flow = useUsageSignupFlow({
    cycle: transferCycle,
    isUpgrade: true,
  });

  const mutateDowngradeCycle = useStatusMutation(postDowngradeCycle, {
    onSuccess: () => {
      onModal();
      updateCurrentAccount();
    },
  });

  const onMutateDowngrade = useCallback(() => {
    if (!mutateDowngradeCycle.idle) return;
    mutateDowngradeCycle.mutate({
      accountId,
      payload: { cycle: transferCycle },
    });
  }, []);

  return (
    <UpgradeCycleModalPresenter
      currentCycle={cycle}
      onModal={onModal}
      onConfirmToMonthly={onConfirmToMonthly}
      flow={flow}
    />
  );
}
